import {
  put,
  takeEvery
}                        from 'redux-saga/effects';
import { ACTIONS }       from './../../actions/utils/apiResources/apiResourceActions.const';
import {
  buildMethodsByActionGroup,
  isApiSuccessAction,
  parseApiAction
}                        from './../../actions/utils/apiResources/buildSyncActions';
import { resourceNames } from './../../config/resources.config';


/**
 * Sets up watchers for successful shortlists
 */
export function* autoloadShortlistServices() {

  yield takeEvery(
    (action) => isApiSuccessAction(action)
      && resourceNames.SHORTLISTS === parseApiAction(action).resourceName
      && ACTIONS.DEL !== parseApiAction(action).actionGroup,
    loadShortlistServices
  );

}

export function* loadShortlistServices(action) {

  const actionGroup = parseApiAction(action).actionGroup;

  const {payload: {receivedData}} = action;

  switch (actionGroup) {

    case ACTIONS.SHOW:

      const servicesRequest = buildMethodsByActionGroup[ACTIONS.LIST](resourceNames.SERVICES)
        .request({url: `${receivedData['@id']}/services`});

      yield put(servicesRequest);

      return;

    default:

      throw new Error(`Add code to handle shortlists '${actionGroup}' action group.`);

  }

}


// WEBPACK FOOTER //
// ./src/sagas/resources/autoloadShortlistServices.js